import React, { useEffect } from "react";
import { Box, TextField, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import DocumentItem from "../../../../Components/Masters/DocumentItem";
import { getMonthName } from "../../../../utils/getMonthName";
import { truncateNumber } from "../../../../utils/common";
function ViewConsumptions(props) {
  useEffect(() => {
    console.log(props.selectedData, "selectedData");
  }, [props]);

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.5rem",
        height: "100vh",
        display: "flex",
        justifyContent: "space-btween",
        backgroundColor: "transparent",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton
          onClick={() => props.setView(false)}
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          padding: "24px",
          backgroundColor: "#fff",
          height: "100%",
          width: "100%",
          overflowY: "scroll",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",

            mb: 2,
          }}
        >
          Consumption by Equipment Details
        </Typography>
        <Box display="flex" gap={10}>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              Date
            </Typography>

            <p>
              {new Date(props.selectedData?.createdAt).toLocaleDateString(
                "en-GB",
                { day: "2-digit", month: "2-digit", year: "numeric" }
              ) ?? ""}
            </p>
          </Box>

          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              Consumption Month
            </Typography>
            <Typography>
              {getMonthName(props.selectedData?.consumptionPeriod?.month) +
                " " +
                props.selectedData?.consumptionPeriod?.year}
            </Typography>
          </Box>
        </Box>

        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
            Equipment
          </Typography>
          <p> {props.selectedData?.equipment?.equipment ?? ""}</p>
        </Box>

        <Box display="flex" gap={5}>
          <Box style={{ width: "100%" }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              Brand
            </Typography>
            <p> {props.selectedData?.brand ?? ""}</p>
          </Box>
          <Box style={{ width: "100%" }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              Model
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {props.selectedData?.model ?? ""}
            </p>
          </Box>
        </Box>

        <Box display="flex" gap={5}>
          <Box style={{ width: "100%" }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              Units Consumed
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {props.selectedData?.unitOfConsumption === ""
                ? "-"
                : truncateNumber(props.selectedData?.unitOfConsumption)}
            </p>
          </Box>
          <Box style={{ width: "100%" }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              Hours Used
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {props.selectedData?.usedHours ?? ""}
            </p>
          </Box>
        </Box>

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
          Remark (optional)
        </Typography>
        <p>{props.selectedData?.remarks ? props.selectedData?.remarks : "-"}</p>
        {/* <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
       Reson's For Deviation
        </Typography>
        <p>{props.selectedData?.reasonForDeviation ?? "-"}</p> */}
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            Documents (optional)
          </Typography>
          <Box
            display="flex"
            flexDirection="column"
            gap={1}
            sx={{ width: "100%" }}
          >
            {/* Render Images First */}
            {props.selectedData !== null
              ? props.selectedData &&
                props.selectedData?.documents?.length > 0 && (
                  <Box display="flex" flexWrap="wrap" gap={1}>
                    {props.selectedData?.documents
                      .filter((url) =>
                        ["png", "jpg", "jpeg"].includes(
                          url.split(".").pop().toLowerCase()
                        )
                      )
                      .map((url, index) => (
                        <DocumentItem key={`image-${index}`} url={url} />
                      ))}
                  </Box>
                )
              : "-"}

            {/* Render Other Documents */}
            {props.selectedData && props.selectedData?.documents.length > 0 ? (
              <Box display="flex" flexWrap="wrap" gap={1}>
                {props.selectedData?.documents
                  .filter(
                    (url) =>
                      !["png", "jpg", "jpeg"].includes(
                        url.split(".").pop().toLowerCase()
                      )
                  )
                  .map((url, index) => (
                    <DocumentItem key={`file-${index}`} url={url} />
                  ))}
              </Box>
            ) : (
              "-"
            )}
          </Box>
        </Box>

        {!props?.companyAdmin && (
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={() =>
              props.selectedData?._id !== null &&
              props.handleEdit(props.selectedData)
            }
          >
            Edit
          </Button>
        )}
      </Box>
    </Box>
  );

  return (
    <div>
      <Drawer
        sx={{
          backgroundColor: "transparent",
          "& .MuiDrawer-paper": {
            // This targets the paper component within the Drawer
            backgroundColor: "transparent", // Make paper transparent
            boxShadow: "none", // Optional: Remove any shadow
          },
        }}
        anchor="right"
        open={props.view}
        onClose={() => props.setView(false)}
      >
        {list()}
      </Drawer>
    </div>
  );
}

export default ViewConsumptions;
